import { Box } from "@mui/material";
import React from "react";

export const HeaderWelcome = () => <Box sx={{ flexGrow: 1 }} />;
